const trackingConstants = {
  EC_VIEW: "ecView",
  EC_FILTER_CRITERIA: "ecFilterCriteria",
  EC_PLP_PRODUCTS: "ecPLPProducts",
  EC_PRODUCT: "ecProduct",
  EMAIL_NEWS_LETTER_SIGNUP: "Email_newsletter_signup",
  GIFT_WRAP_SUCCESS: "Gift_Wrap",
  LAYER_AUTHENTICATION: "authentication",
  LAYER_PRODUCT_VIEW: "productView",
  LAYER_PRODUCT_COLOR_SELECTED: "productColorSelected",
  LAYER_FACET_FILTER: "facetFilter",
  LAYER_SELECTED_SORT: "selectedSortName",
  LAYER_SHOPPING_CART: "shoppingCartView",
  LAYER_PAGE: "page",
  LAYER_PRODUCT_REMOVED: "productRemoved",
  LAYER_PRODUCT_COUNT: "productCount",
  LOGIN_SUCCESS: "Login_Success",
  LOGIN_FAILED: "Login_Failure",
  ORDER_CONFIRMED: "orderConfirmation_Success",
  ORDER_FAILED: "orderConfirmation_Failure",
  REGISTRATION_FAILED: "Registration_Failure",
  REGISTRATION_SUCCESS: "Registration_Success",
  PRODUCT_ADDED_TO_CART: "Product_AddToCart",
  PRDOUCT_REMOVED_FROM_CART: "shoppingCart_Remove",
  PRODUCT_VIEW: "Product_View",
  SHOPPING_CART_VIEW: "shoppingCart_View",
  SHOPPING_CART_TO_CHECKOUT: "shoppingCart_Checkout",
  SHIPPING_INFO: "shipping_info",
  PRODUCT_VIEW_CONTENT_SELECTION: "Product_viewContent_Selection",
  SORT_BY_CHANGED: "Sort_by_usage",
  FILTER_APPLIED: "Facet_filter",
  PLP_CLICK: "plp_click",
  SC_OPEN: "sc_open",
  PAGE_VIEW: "page_view",
  VIEW_ORDER_HISTORY: "view_order_history",
  VIEW_ACCOUNT_DETAILS: "view_account_details",
  PDP_IMAGE_CLICK: "pdp_image_click",
  INTERNAL_SEARCH: "internal_search",
  PAGE_NOT_FOUND_ERR: "404_page_view",
  PRODUCT_COLOR_SELECTED: "product_color_selection",
  QUICK_VIEW: "quick_view",
  PRODUCT_SIZE_CHART: "product_size_chart",
  SOCIAL_SHARE: "social_share",
  PRODUCT_FIND_IN_STORE: "product_find_in_store",
  PRODUCT_FIND_IN_STORE_SUCCESS: "product_find_in_store_success",
  LAYER_RESERVE_PRODUCT_STORE: "reserveProductStore",
  RESERVE_STORE_SUCCESS: "reserve_store_success",
  LAYER_QUICK_VIEW: "quickView",
  LAYER_CHECKOUT_PAGE: "checkoutPageView",
  STACK_IT_MODAL: "stack_it_modal",
  PDP_INQUIRY_REQUEST_FORM: "pdp_inquiry_request_form",
  CALL_ONLY_PURCHASE: "call_only_purchase",
  ADD_TO_BAG_STACK_IT: "add_to_bag_stack_it",
  ADD_TO_WISHLIST: "add_to_wishlist",
  LAYER_PREVPAGE_URL: "prevPageURL",
  GIFT_GUIDE_CLICK: "gift_guide_click",
  EC_BASKET_ITEM: "ecBasketItem",
  EC_BASKET_SUMMARY: "ecBasketSummary",
  LAYER_TYPEAHEAD_SUGGEST: "suggest",
  TYPEAHEAD_SUGGESTION_CLICK: "suggestion_click",
}

export default trackingConstants
